import axios from 'axios'

import { Address } from 'common/server/addresses'
import { AddressTo } from 'common/server/addressesTo'
import { DeliveryChargesUnit } from 'common/server/deliveries'
import { DeliveryIssueTypes, File } from 'common/server/server_types'

export interface DeliveryUpdateResponse {
  order: {
    id: string
    project_id: string
    order_package_name: string
    vendor_name: string
  }
  delivery: Delivery
}

export interface Delivery {
  actual_delivered_at: string
  address: Address
  address_to?: AddressTo
  carrier: string
  delivery_files: File[]
  delivery_issue_resolved_at: string
  delivery_issue_type: DeliveryIssueTypes
  delivery_issues: string
  estimated_delivered_at: string
  has_open_issue: boolean
  id: string
  instructions: string
  lead_time_days: number
  marked_delivered_at: string
  marked_shipped_at: string
  requested_delivered_at: string
  shipped_at: string
  state: string
  tracking_number: string
  marked_delivered_by?: { id: string; first_name: string; last_name: string; email: string }
  delivery_issue_resolved_by?: { id: string; first_name: string; last_name: string; email: string }
  tax_value?: number
  discount_value?: number
  shipping_value?: number
  other_value?: number

  shipping_carrier_id?: string
  is_pick_up: boolean
}

export interface DeliveryUpdateParams {
  id?: string
  state: string
  // Request
  address: Address
  requested_delivered_at: string
  instructions: string
  // Shipping
  shipped_at: string
  carrier: string
  shipping_carrier_id?: string
  tracking_number: string
  estimated_delivered_at: string
  actual_delivered_at: string
  // Receiving
  marked_delivered_at?: string
  marked_delivered_by?: { id: string; first_name: string; last_name: string; email: string }
  delivery_issues: string
  delivery_issue_type: DeliveryIssueTypes
  delivery_issue_resolved_at?: string
  delivery_issue_resolved_by?: { id: string; first_name: string; last_name: string; email: string }
  lead_time_days?: number
  has_open_issue: boolean
  // values
  tax_value?: number
  discount_value?: number
  shipping_value?: number
  other_value?: number

  delivery_charges_units?: DeliveryChargesUnit
}

export function show(id: string) {
  return axios.get<Delivery>(`/vendor/deliveries/${id}`)
}

export function update(payload: DeliveryUpdateParams) {
  return axios.patch<DeliveryUpdateResponse>(`/vendor/deliveries/${payload['id']}`, payload)
}
